import React from 'react'
import PropTypes from 'prop-types'

import Logo from './Logo'
import * as scenes from '../scenes'

const LogoContainer = ({ settings, scene }) => {
  let image = settings.intro.logo
  let customClassName = 'in_static-logo-intro'
  let id = 'in_static-logo-intro'
  if (scene === scenes.SHOWCASE) {
    if (settings.intro.showcaseLogo) image = settings.intro.showcaseLogo
    customClassName = 'in_showcases_logo'
    id = 'in_showcases_logo'
  }
  return (
    <Logo
      image={image}
      customClassName={customClassName}
      id={id}
    />
  )
}

LogoContainer.propTypes = {
  settings: PropTypes.object,
  scene: PropTypes.string
}

export default LogoContainer



// WEBPACK FOOTER //
// ./src/templates/insta/components/LogoContainer.js